import {
  jobMatches,
  listSummary,
  withinDateFilter,
  type DateFilter,
  type NavItem,
} from "@roof-hawk/core";
import { useMemo, useState } from "react";

import { JobRows, JobsSummary, ListHead } from "../../components/ui";
import { t } from "../../i18n";
import type { AppData } from "../shell/Shell";

/**
 * Prospects and Jobs are the same list split on `sends_at`: a job that has been
 * handed to production is no longer a prospect.
 */
export function JobsList({
  view,
  data,
  search,
}: {
  view: NavItem;
  data: AppData;
  search: string;
}) {
  const [dateFilter, setDateFilter] = useState<DateFilter>("all");
  const isProspects = view === "Prospects";

  const rows = data.jobs
    .filter((job) => (isProspects ? !job.sends_at : Boolean(job.sends_at)))
    .filter((job) => withinDateFilter(job, dateFilter))
    .filter((job) => jobMatches(job, search));

  const values = data.values;
  const approvals = data.approvals;
  const summary = useMemo(
    () => (values ? listSummary(rows, values, new Date(), approvals) : null),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [rows.map((job) => job.id).join(","), values, approvals],
  );

  return (
    <>
      <ListHead
        title={t(view)}
        count={rows.length}
        dateFilter={dateFilter}
        onDateFilter={setDateFilter}
      />
      <JobsSummary summary={summary} />
      <JobRows jobs={rows} values={values} />
    </>
  );
}
